import script from "./HispFeatures.vue?vue&type=script&setup=true&lang=ts"
export * from "./HispFeatures.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__